<div
    [id]="data"
    class="google-ad-container hmf-mt-s hmf-mx-auto hmf-mb-0">
</div>
<div
	class="hmf-display-flex hmf-align-items-center hmf-justify-content-end hmf-mb-s"
	id="sponsoredLabel"
    [ngClass]="{'dsg-store-sponsored-tag': isDsgStorePage}">
        <button
			*ngIf="showSponsoredLabel"
            id="sponsoredButton"
            class="sponsored-button hmf-display-flex"
            (click)="loadSurvey()">
            <p class="sponsored-text hmf-body-s">
                Sponsored
            </p>
            <homefield-icon
                *ngIf="enableTooltipSurvey()"
                width="14px"
                height="14px"
                name="alert-info-filled"
                class="hmf-flex-shrink-none" />
        </button>
</div>
